import { type CSSProperties, memo, ReactNode } from "react"
import { useMediaQuery } from "react-responsive"
import { ReloadButton } from "~/shared/ui/layouts/main/ReloadButton"

import cssModule from "./index.module.scss"
import { breakPoints } from "~/shared/ui/constants"
import { IconButtonProps } from "~/shared/ui"
import { MenuButton } from "~/shared/ui/layouts/main/MenuButton"
import { isStandalone } from "~/shared/lib/utils"

export const Userbar = memo(function Userbar({
												 element,
												 hideCurtain,
												 showMenuButton,
												 onMenuButtonClick,
												 customization
											 }: {
	element: ReactNode,
	hideCurtain: boolean,
	showMenuButton: boolean,
	onMenuButtonClick?: () => void,
	customization: {
		closeMenuButton?: {
			colorStyle?: IconButtonProps["colorStyle"]
			style?: CSSProperties
			className?: string
		}
	}
}) {
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	return (
		<div className={cssModule.userbar}>
			{isSmallDevice && showMenuButton &&
				<MenuButton hideCurtain={hideCurtain}
							closeMenuButton={customization.closeMenuButton}
							onClick={onMenuButtonClick} />}
			{element}
			{isStandalone() && <ReloadButton />}
			{/*!isStandalone() && isSmallDevice && <div style={{ width: "3.25rem" }}></div>*/}
		</div>
	)
})
